define(function(require, exports, module) {
    'use strict';

    var CarouselClass = require('class/totalcasino-theme/carousel.class');
    var BaseReplacerView = require('common/base.replacer.view');
    var core = require('core');

    module.exports = BaseReplacerView.extend({
        render : function() {
            var webContentID = this.options.params[0];
            this.loadContent(webContentID)
                .done(this.renderArticle.bind(this));
            return this;
        },

        renderArticle: function(data) {
            this.$el.html(this.tmpl('carousel', {
                webContent: data
            }));

            if(this.$('.carousel__wrap')[0].offsetWidth === 0) {
                this.listenTo(core, 'after:render', this.carouselInit.bind(this));
            } else {
                this.carouselInit();
            }
        },

        carouselInit: function() {
            var $mainEl = this.$('.carousel__wrap');
            var $carouselTrack = this.$('.carousel__track');
            var carouselItemSelector = '.carousel__item';
            var carouselOptions = {
                scrollSize: 1,
                $scrollLeft: this.$('.fn-scroll-left'),
                $scrollRight: this.$('.fn-scroll-right'),
                infinityMode: true
            };

            this.caroseulView = new CarouselClass($mainEl, $carouselTrack, carouselItemSelector, carouselOptions);
        },

        remove: function() {
            BaseReplacerView.prototype.remove.apply(this, arguments);
            this.caroseulView && this.caroseulView.close();
            this.stopListening(core, 'after:render', this.carouselInit.bind(this));
        }

    }, {
        nameOfReplacers: [
            'CAROUSEL'
        ]
    });
});